import {useQuery} from "@tanstack/react-query";
import {readRevenueByVertical} from "../../../../../api/main/DashboardApi";

export const useReadRevenueByVertical = () => {
    const {data} = useQuery({
        queryKey: ["readRevenueByVertical"],
        queryFn: async () => await readRevenueByVertical(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};